import styled from 'styled-components';

export const InputsContainer = styled.section`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  gap: 0.4375rem;
  width: 100%;
  flex-wrap: wrap;

  #busca_parceiro {
    width: 21.875rem;
  }

  @media only screen and (max-width: 1550px) {
    flex-direction: column;
    align-items: center;

    input,
    #busca_parceiro {
      width: 27.8125rem;
    }
  }
`;

export const CustomButtonsContainer = styled.section`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.4375rem;
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
`;
